module.exports = __webpack_public_path__ + "img/text-classify1.447e4e04.png";